<div class="container-fluid p-0">
  <div class="row no-gutters">
    <div class="col-lg-2">
      <app-navbar></app-navbar>
    </div>
    <div class="col-lg-10 contenido">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Productos (V2)</h4>
        <span *ngIf="loading" class="badge badge-info">Cargando...</span>
      </div>
      <hr />

      <div class="card mb-3">
        <div class="card-body">
          <h6 class="card-title">Agregar producto nuevo</h6>
          <div class="form-row align-items-end">
            <div class="col-md-2">
              <label class="font-weight-bold">Nombre</label>
              <input class="form-control" [(ngModel)]="formulario.nombre" placeholder="Producto light" />
            </div>
            <div class="col-md-2">
              <div class="d-flex justify-content-between">
                <label class="font-weight-bold">Tipo</label>
                <button type="button" class="btn btn-secondary btn-sm" (click)="abrirAgregarTipo(tipoProductoModal, 'nuevo')">Agregar</button>
              </div>
              <select class="form-control" [(ngModel)]="formulario.tipo">
                <option value="" disabled>Selecciona tipo</option>
                <option *ngFor="let tipo of getTiposProducto()" [value]="tipo">{{ tipo }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Descripcion</label>
              <input class="form-control" [(ngModel)]="formulario.descripcion" placeholder="Detalle visible al usuario" />
            </div>
            <div class="col-md-2">
              <label class="font-weight-bold">Imagen principal</label>
              <input type="file" class="form-control-file" (change)="onFileChangeNuevo($event)" />
            </div>
            <div class="col-md-1">
              <label class="font-weight-bold">Activo</label>
              <select class="form-control" [(ngModel)]="formulario.activo">
                <option [value]="1">Si</option>
                <option [value]="0">No</option>
              </select>
            </div>
            <div class="col-md-2 mt-3 mt-md-0">
              <button class="btn btn-success btn-block" (click)="agregarProducto()">Guardar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h6 class="card-title mb-0">Catalogo v2 independiente</h6>
            <div class="filters-row">
              <input class="form-control" [(ngModel)]="filtro" placeholder="Buscar nombre o descripcion" />
              <select class="form-control" [(ngModel)]="filtroTipo">
                <option value="">Todos los tipos</option>
                <option *ngFor="let tipo of tiposProductos" [value]="tipo">{{ tipo }}</option>
              </select>
              <select class="form-control" [(ngModel)]="filtroActivo">
                <option value="">Todos</option>
                <option value="1">Activos</option>
                <option value="0">Inactivos</option>
              </select>
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th>Descripcion</th>
                  <th>Imagen</th>
                  <th>Fotos</th>
                  <th>Activo</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let producto of productosFiltrados">
                  <td>{{ producto.nombre }}</td>
                  <td>{{ producto.tipo || '-' }}</td>
                  <td>{{ producto.descripcion || '-' }}</td>
                  <td>
                    <img [src]="getProductoPrincipal(producto)" alt="img producto" class="thumb">
                  </td>
                  <td>{{ producto.imagenes?.length || 0 }}</td>
                  <td>
                    <span class="badge" [ngClass]="producto.activo === 0 ? 'badge-secondary' : 'badge-success'">
                      {{ producto.activo === 0 ? 'No' : 'Si' }}
                    </span>
                  </td>
                  <td class="text-right actions-cell">
                    <button class="btn btn-sm btn-outline-secondary" (click)="abrirImagenes(imagenesModal, producto)">Fotos</button>
                    <button class="btn btn-sm btn-outline-secondary" (click)="abrirVariaciones(variacionesModal, producto)">Variaciones</button>
                    <button class="btn btn-sm btn-outline-primary" (click)="abrirEditar(editProductoModal, producto)">Editar</button>
                    <button class="btn btn-sm btn-outline-warning" (click)="toggleProductoActivo(producto)">
                      {{ producto.activo === 0 ? 'Activar' : 'Desactivar' }}
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="eliminarProducto(producto.id)">Eliminar</button>
                  </td>
                </tr>
                <tr *ngIf="!productosFiltrados.length">
                  <td colspan="7" class="text-center text-muted">Sin productos v2.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editProductoModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-editar-producto">Editar producto v2</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="formularioEdit.nombre" />
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label class="font-weight-bold">Tipo</label>
        <button type="button" class="btn btn-secondary btn-sm" (click)="abrirAgregarTipo(tipoProductoModal, 'editar')">Agregar</button>
      </div>
      <select class="form-control" [(ngModel)]="formularioEdit.tipo">
        <option value="" disabled>Selecciona tipo</option>
        <option *ngFor="let tipo of getTiposProducto(formularioEdit.tipo)" [value]="tipo">{{ tipo }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <textarea class="form-control" rows="3" [(ngModel)]="formularioEdit.descripcion"></textarea>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Imagen principal</label>
      <input type="file" class="form-control-file" (change)="onFileChangeEditar($event)" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="formularioEdit.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="actualizarProducto()">Guardar</button>
  </div>
</ng-template>

<ng-template #tipoProductoModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-agregar-tipo-producto">Agregar tipo</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="tipoForm.nombre" placeholder="Ej. Marco, Moldura, Color" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <textarea class="form-control" rows="3" [(ngModel)]="tipoForm.descripcion" placeholder="Detalle interno opcional"></textarea>
    </div>

    <hr />

    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h6 class="mb-0">Tipos registrados</h6>
      <input class="form-control tipo-search" [(ngModel)]="filtroTipoCatalogo" placeholder="Buscar tipo" />
    </div>

    <div class="tipo-list mt-3">
      <div class="tipo-row" *ngFor="let tipo of tiposProductoCatalogoFiltrados">
        <div>
          <strong>{{ tipo.nombre }}</strong>
          <small *ngIf="tipo.descripcion">{{ tipo.descripcion }}</small>
        </div>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="eliminarTipoProducto(tipo)">Eliminar</button>
      </div>
      <div class="text-muted py-2" *ngIf="!tiposProductoCatalogoFiltrados.length">Sin tipos registrados.</div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="agregarTipoProducto()">Guardar tipo</button>
  </div>
</ng-template>

<ng-template #variacionesModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-variaciones">Variaciones de {{ productoSeleccionado?.nombre }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex align-items-end justify-content-between flex-wrap">
      <div class="variation-picker-search">
        <label class="font-weight-bold">Buscar variacion</label>
        <input class="form-control" [(ngModel)]="filtroVariacionBase" placeholder="Principal, secundaria, extra..." />
      </div>
      <div class="variation-picker-actions mt-3 mt-md-0">
        <span class="badge badge-light">Tipo: {{ productoTipoRelacion || '-' }}</span>
        <button
          class="btn btn-outline-secondary"
          (click)="seleccionarTodasVariacionesDisponibles()"
          [disabled]="!variacionesBaseProductoDisponiblesFiltradas.length">
          Seleccionar todos
        </button>
      </div>
    </div>

    <div class="variation-checkbox-list mt-3" *ngIf="productoTipoRelacion; else productoSinTipo">
      <label class="variation-checkbox" *ngFor="let variacion of variacionesBaseProductoDisponiblesFiltradas">
        <input
          type="checkbox"
          [checked]="isVariacionSeleccionada(variacion.id)"
          (change)="toggleVariacionSeleccionada(variacion.id, $any($event.target).checked)" />
        <span>
          <strong>{{ getVariacionBaseLabel(variacion) }}</strong>
          <small>{{ variacion.configuraciones?.length || 0 }} item(s)</small>
        </span>
      </label>
      <div class="text-muted py-2" *ngIf="!variacionesBaseProductoDisponiblesFiltradas.length">
        Sin variaciones disponibles para este tipo.
      </div>
    </div>

    <ng-template #productoSinTipo>
      <div class="text-muted mt-3">Producto sin tipo. Asigna tipo para relacionar variaciones.</div>
    </ng-template>

    <div class="d-flex align-items-center justify-content-between flex-wrap mt-3">
      <span class="text-muted">{{ variacionesSeleccionadas.length }} variacion(es) seleccionada(s)</span>
      <button class="btn btn-success" (click)="agregarVariacion()" [disabled]="!variacionesSeleccionadas.length">Agregar</button>
    </div>

    <div class="d-flex align-items-center justify-content-between flex-wrap mt-4">
      <h6 class="mb-0">Permisos de variacion</h6>
      <input class="form-control modal-search" [(ngModel)]="filtroVariacion" placeholder="Buscar asignada" />
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Variacion</th>
            <th>Items visibles</th>
            <th>Activo</th>
            <th class="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let variacion of variacionesFiltradas">
            <td>{{ getVariacionBaseNombre(variacion) }}</td>
            <td>
              <div class="config-list">
                <span class="config-pill" *ngFor="let config of getVariacionConfiguraciones(variacion)">
                  <img *ngIf="config.imagen" [src]="buildImagePath(config.imagen)" alt="" />
                  <strong>{{ config.configuracion }}</strong>
                  <small *ngIf="config.descripcion">{{ config.descripcion }}</small>
                  <small *ngIf="config.activo === 0">(inactiva)</small>
                </span>
                <span *ngIf="!getVariacionConfiguraciones(variacion).length">-</span>
              </div>
            </td>
            <td>{{ variacion.activo === 0 ? 'No' : 'Si' }}</td>
            <td class="text-right actions-cell">
              <button class="btn btn-sm btn-outline-secondary" (click)="configurarVariacionProducto(variacion)">Configurar</button>
              <button class="btn btn-sm btn-outline-warning" (click)="toggleVariacionProducto(variacion)">
                {{ variacion.activo === 0 ? 'Activar' : 'Desactivar' }}
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="eliminarVariacion(variacion.id)">Eliminar</button>
            </td>
          </tr>
          <tr *ngIf="!variacionesFiltradas.length">
            <td colspan="4" class="text-center text-muted">Sin variaciones asignadas.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card mt-3" *ngIf="productoVariacionConfigurando">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <h6 class="card-title mb-0">Items visibles de {{ getVariacionBaseNombre(productoVariacionConfigurando) }}</h6>
          <input class="form-control modal-search" [(ngModel)]="filtroConfiguracionProducto" placeholder="Buscar asignada" />
        </div>

        <div class="form-row align-items-end mt-3">
          <div class="col-md-4">
            <label class="font-weight-bold">Filtrar items</label>
            <input
              class="form-control"
              [ngModel]="configuracionProductoInput"
              (ngModelChange)="onConfiguracionProductoInputChange($event)"
              placeholder="Madera, metal, nogal..." />
          </div>
          <div class="col-md-5">
            <label class="font-weight-bold">Item visible</label>
            <select class="form-control" [(ngModel)]="configuracionProductoSeleccionada">
              <option [ngValue]="null" disabled>Seleccione item</option>
              <option *ngFor="let config of configuracionesBaseDisponiblesProducto" [ngValue]="config.id">
                {{ getConfiguracionOptionLabel(config) }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mt-md-0">
            <button class="btn btn-success btn-block" (click)="agregarConfiguracionProducto()">Agregar item</button>
          </div>
          <div class="col-12 mt-2 text-muted">
            {{ configuracionesBaseDisponiblesProducto.length }} item(s) disponibles
            <span *ngIf="loadingProductoConfiguraciones"> - Cargando...</span>
          </div>
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Item</th>
                <th>Descripcion</th>
                <th>Imagen</th>
                <th>Fotos</th>
                <th>Activo</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let relacion of configuracionesProductoFiltradas">
                <td>{{ getConfiguracionRelacionNombre(relacion) }}</td>
                <td>{{ getConfiguracionRelacionDescripcion(relacion) || '-' }}</td>
                <td><img [src]="getConfiguracionRelacionImagen(relacion)" alt="img config" class="thumb"></td>
                <td>{{ getConfiguracionRelacionFotos(relacion) }}</td>
                <td>{{ relacion.activo === 0 ? 'No' : 'Si' }}</td>
                <td class="text-right actions-cell">
                  <button class="btn btn-sm btn-outline-warning" (click)="toggleConfiguracionProducto(relacion)">
                    {{ relacion.activo === 0 ? 'Activar' : 'Desactivar' }}
                  </button>
                  <button class="btn btn-sm btn-outline-danger" (click)="eliminarConfiguracionProducto(relacion)">Quitar</button>
                </td>
              </tr>
              <tr *ngIf="!configuracionesProductoFiltradas.length">
                <td colspan="6" class="text-center text-muted">Sin items asignados a esta variacion.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<ng-template #imagenesModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-imagenes-producto">Fotos de {{ productoSeleccionado?.nombre }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row align-items-end">
      <div class="col-md-4">
        <label class="font-weight-bold">Titulo comun</label>
        <input class="form-control" [(ngModel)]="productoImagenForm.titulo" placeholder="Frente, detalle, textura" />
      </div>
      <div class="col-md-2">
        <label class="font-weight-bold">Orden inicial</label>
        <input class="form-control" type="number" [(ngModel)]="productoImagenForm.orden" />
      </div>
      <div class="col-md-2">
        <label class="font-weight-bold">Activo</label>
        <select class="form-control" [(ngModel)]="productoImagenForm.activo">
          <option [value]="1">Si</option>
          <option [value]="0">No</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="font-weight-bold">Imagenes</label>
        <input type="file" class="form-control-file" multiple (change)="onProductoImagenesChange($event)" />
      </div>
      <div class="col-md-3 mt-3">
        <button class="btn btn-success btn-block" (click)="agregarImagenesProducto()">Agregar fotos</button>
      </div>
      <div class="col-md-9 mt-3 text-muted">
        {{ productoImagenFiles.length || 0 }} archivo(s) seleccionados
        <span *ngIf="loadingImagenes"> - Cargando...</span>
      </div>
    </div>

    <div class="gallery-grid mt-4">
      <div class="gallery-item" *ngFor="let imagen of imagenesProducto">
        <img [src]="buildImagePath(imagen.imagen)" alt="foto producto">
        <div>
          <strong>{{ imagen.titulo || 'Sin titulo' }}</strong>
          <small>Orden {{ imagen.orden || 0 }}</small>
          <span class="badge" [ngClass]="imagen.activo === 0 ? 'badge-secondary' : 'badge-success'">
            {{ imagen.activo === 0 ? 'Inactiva' : 'Activa' }}
          </span>
        </div>
        <div class="d-flex justify-content-between">
          <button class="btn btn-sm btn-outline-warning" (click)="toggleProductoImagen(imagen)">
            {{ imagen.activo === 0 ? 'Activar' : 'Desactivar' }}
          </button>
          <button class="btn btn-sm btn-outline-danger" (click)="eliminarProductoImagen(imagen)">Eliminar</button>
        </div>
      </div>
      <p *ngIf="!imagenesProducto.length" class="text-muted">Sin fotos adicionales.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>
